<template>
  <div
    class="cookie-disclaimer modal"
    v-if="cookies"
  >
    <div class="cookie-disclaimer__image">
      <img
        :src="baseAssetsUrl + '/staticImages/cookie.svg'"
        :alt="$t('cookie.disclaimer.alt')"
        height="45"
        width="38"
        loading="lazy"
      >
    </div>
    <div class="cookie-disclaimer__container">
      <div class="cookie-disclaimer__text">
        <div class="cookie-disclaimer__text--header">
          {{ $t('cookie.disclaimer.text.header') }}
        </div>
        <p v-html="$t('cookie.disclaimer.text', ['/datenschutz/'])" />
      </div>
      <div class="cookie-disclaimer__buttons">
        <div
          class="button--reject"
          v-html="$t('cookie.disclaimer.reject')"
          @click="rejectAll"
          role="button"
          :aria-label="$t('global.cookie.reject.button.aria.label')"
          @keydown="handleKeyDown"
        />
        <div class="button--accept">
          <button
            class="button--accept-all button button--alt"
            v-html="$t('cookie.disclaimer.accept')"
            @click="acceptAll"
            role="button"
            :aria-label="$t('global.accept.all.cookies.button')"
            @keydown="handleKeyDown"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '../checkbox/checkbox.vue'
import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js'
import cookieMonster from '../../utilities/js/cookieMonster/cookieMonster.js'

export default {
  mixins: [
    globalStateComputedMixin
  ],
  props: {
    cookieName: {
      type: String,
      default: 'COOKIECONSENT'
    },
    expireInDays: {
      type: Number,
      default: 60
    }
  },
  components: {
    Checkbox
  },
  data() {
    return {
      cookies: null
    }
  },
  created() {
    this.setInitialValue()
    if (this.cookies) {
      this.$store.state.isOverlayVisible = true
    }
  },
  methods: {
    setInitialValue() {
      if (!cookieMonster.get(this.cookieName)) {
        this.cookies = {
          other: false,
          tracking: false,
          marketing: false,
          essential: true
        }
      }
    },
    acceptAll() {
      this.cookies.other = true
      this.cookies.tracking = true
      this.cookies.marketing = true
      this.saveSelection()
    },
    rejectAll() {
      this.cookies.other = false
      this.cookies.tracking = false
      this.cookies.marketing = false
      this.saveSelection()
    },
    saveSelection() {
      let expireDate = (new Date()).getTime() + 86400000 * this.expireInDays
      cookieMonster.set(this.cookieName, btoa(JSON.stringify(this.cookies)), new Date(expireDate))
      this.cookies = null
      this.$store.state.isOverlayVisible = false
      // Workaround for iOS page reload issue
      // setTimeout(() => window.location.reload());
      window.location = window.location.href
    },
    handleKeyDown(event) {
      if (event.key === 'Enter' || event.code === 'Space') {
        event.preventDefault();
        event.target.click();
      }
    }
  }
}

</script>
